export function isProduction(): boolean {
  const hostname = window.location.hostname;
  return hostname !== "localhost" && !hostname.includes("amazonaws.com");
}

export function isLocal(): boolean {
  return process.env.REACT_APP_ENV === "LOCAL";
}

export function getEnvironment(): string {
  const hostname = window.location.hostname;
  switch (hostname) {
    case HOSTNAMES.TEST:
      return ENVIRONMENT_NAMES.TEST;
    case HOSTNAMES.PRE_PROD:
      return ENVIRONMENT_NAMES.PRE_PROD;
    case HOSTNAMES.PRD:
      return ENVIRONMENT_NAMES.PRD;
    case HOSTNAMES.DEV:
      return ENVIRONMENT_NAMES.DEV;
    case HOSTNAMES.STABLE:
      return ENVIRONMENT_NAMES.STABLE;
    default:
      if (isLocal()) return ENVIRONMENT_NAMES.LOCAL;
      return ENVIRONMENT_NAMES.LOCAL_DEV;
  }
}

export const HOSTNAMES = {
  DEV: "d2wijxmnwx1ege.cloudfront.net",
  STABLE: "d371unhknzelek.cloudfront.net",
  TEST: "icargatest.talma.aero",
  PRD: "talmaclick.apptalma.com",
  PRE_PROD: "d3axl5kawfdmwx.cloudfront.net",
};

export const ENVIRONMENT_NAMES = {
  DEV: "DEV",
  STABLE: "STABLE",
  TEST: "TEST",
  PRD: "PRD",
  PRE_PROD: "PRE_PROD",
  LOCAL_DEV: "LOCAL_DEV",
  LOCAL: "LOCAL",
};
